
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__sunset","width":"16","height":"16","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 12h-4.78a3 3 0 10-4.44 0H1a.5.5 0 000 1h14a.5.5 0 000-1zm-7 0a2 2 0 112-2 2 2 0 01-2 2zm-6.5-1.5h2a.5.5 0 000-1h-2a.5.5 0 000 1zM12 10a.5.5 0 00.5.5h2a.5.5 0 000-1h-2a.5.5 0 00-.5.5zM4.46 7.17a.5.5 0 00.71-.71L3.76 5.05a.5.5 0 10-.71.71zm7.08 0L13 5.76a.5.5 0 00-.71-.71l-1.46 1.41a.5.5 0 10.71.71zM7.65 5.85a.48.48 0 00.7 0l1.42-1.41a.5.5 0 00-.71-.71l-.56.56V2.5a.5.5 0 00-1 0v1.79l-.56-.56a.5.5 0 00-.71.71z"}})])
          )
        }
      }
    